"use strict";

var httpLib = require("./http-library.js");
var publicConfig = require("../public-config.js");
var host = publicConfig.external_address;

// public

var Payments = {
  /**
   * GET Managed Account Stripe Data
   *
   * @function
   * @name getManagedAccountData
   * @param {Function} - Callback
   */

  getManagedAccountData: function getManagedAccountData(ssoid, accessToken, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/accounts"),
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, null);
  },
  /**
  * POST / PUT Managed Account Stripe Data
  *
  * @function
  * @name saveManagedAccountData
  * @param {Function} - Callback
  */

  saveManagedAccountData: function saveManagedAccountData(ssoid, accessToken, payload, isUpdate, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/accounts"),
      method: isUpdate ? 'PUT' : 'POST',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, payload);
  },
  /**
   * GET Recipient Stripe Data
   *
   * @function
   * @name getRecipientData
   * @param {Function} - Callback
   */

  getRecipientData: function getRecipientData(ssoid, accessToken, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/recipients"),
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, null);
  },
  /**
   * GET Customer Stripe Data
   *
   * @function
   * @name getCustomerData
   * @param {Function} - Callback
   */

  getCustomerData: function getCustomerData(ssoid, accessToken, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/cards"),
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, null);
  },
  /**
   * POST Create a Stripe Token with Form ID
   *
   * @function
   * @name createStripeToken (requires Stripe.js to be loaded)
   * @param {String} - Form Element ID
   * @param {String} - tokenType is either bank-account or card
   * @param {Function} - Callback to recieve response from Stripe library
   */

  createStripeToken: function createStripeToken(formElementID, tokenType, cb) {
    var formElement = document.getElementById(formElementID);
    if ('bank-account' === tokenType) {
      Stripe.bankAccount.createToken(formElement, cb);
    } else if ('card' === tokenType) {
      Stripe.card.createToken(formElement, cb);
    }
  },
  /**
   * POST Bank Data
   *
   * @function
   * @name updateBank
   * @param {String} - ssoid
   * @param {String} - accessToken
   * @param {String} - bankToken created from Stripe.js library
   * @param {Object} - payload object takes 'bank_account_token', 'legal_name', & 'type'
   * @param {Boolean} - isVerify is a flag to say whether or not this is an update to an existing bank account's tax info
   * @param {Function} - Callback
   */

  updateBank: function updateBank(ssoid, accessToken, payload, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/recipients"),
      method: 'POST',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, payload);
  },
  /**
   * GET Bank Status Data
   *
   * @function
   * @name getBankStatusData
   * @param {Function} - Callback
   */

  getBankStatusData: function getBankStatusData(ssoid, accessToken, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/bank/ready"),
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, null);
  },
  /**
   * POST Card Data
   *
   * @function
   * @name addCard
   * @param {Function} - Callback
   */

  addCard: function addCard(ssoid, accessToken, cardToken, cb) {
    var requestParams = {
      host: host,
      path: "/v2/payments/users/".concat(ssoid, "/cards/").concat(cardToken),
      method: 'POST',
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    };
    httpLib.request(requestParams, function (res) {
      return cb(res);
    }, null);
  },
  /**
   * POST Upload ID
   *
   * @function
   * @name uploadId
   * @param {Function} - Callback
   */

  uploadId: function uploadId(data, stripePublicKey, stripeAccountId, ssoId, token, cb) {
    $.ajax({
      url: 'https://uploads.stripe.com/v1/files',
      data: data,
      headers: {
        'Authorization': 'Bearer ' + stripePublicKey,
        'Stripe-Account': stripeAccountId
      },
      cache: false,
      contentType: false,
      processData: false,
      type: 'POST'
    }).done(function (data) {
      var payload = {
        legal_entity: {
          verification: {
            document: data.id
          }
        }
      };
      Payments.saveManagedAccountData(ssoId, token, payload, true, function (response) {
        if (200 !== response.statusCode) {
          return cb(true);
        }
        return cb(false, response);
      });
    }).fail(function (response, type, message) {
      return cb(true);
    });
  }
};
module.exports = Payments;